import { seoKeywords } from '../home/Home.seo';

export const caseStudiesSeo = {
  title: 'Rumble Fish | Case Studies',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Discover our expertise in the success stories of our clients! We helped brands like MaketDAO and The Ocean to achieve their business goals with cutting-edge technology solutions. We serve industries like FinTech, Cryptocurrency, Healthcare, and more.',
    },
  ],
};
